module.exports = __webpack_public_path__ + "static/media/arrow_down_grey.6601fe5d.svg";